function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  width: "40",
  height: "40"
}, props), /*#__PURE__*/React.createElement("g", {
  stroke: "#000",
  strokeWidth: "2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.83 3.444L4.338 12.527 9.11 27.222h15.44l4.771-14.695L16.83 3.444z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.49 27.308l-12.666-.164 3.626 9.412h15.44l4.771-14.695-7.654-5.422-3.516 10.87h0z"
})));